import React, { useState } from "react";
import { all_routes } from "../router/all_routes";
import { useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { LANG } from "../../constants/language";
import * as Yup from "yup";
import { useFormik } from "formik";
import { forgotPassword } from "../../services/auth.service";
import { toast } from "react-toastify";
import ErrorText from "../../core/components/error-text";
import { emailRegex } from "../../constants/utlis";
import ArrowUpWhiteIcon from "../../icons/ArrowUpWhiteIcon";

const initialValues = {
  email: "",
};

const forgotPasswordSchema = Yup.object().shape({
  // email: Yup.string().email(LANG.PLEASE_ADD_VALID_EMAIL).required(LANG.EMAIL_IS_REQUIRED),
  email: Yup.string()
    .required(LANG.EMAIL_IS_REQUIRED)
    .matches(emailRegex, LANG.PLEASE_ADD_VALID_EMAIL),
});

const ForgotPassword = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const [error, setError] = useState<any>(null);

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      try {
        const result = await forgotPassword({ email: values.email });
        console.log("result ========= ", result.data?.data);

        console.log(result);
        toast.success("Password reset link sent successfully!");
        setError(null);

        navigate(routes.confirmEmail, { state: { email: values.email } });
      } catch (error) {
        setSubmitting(false);
        setStatus("The login detail is incorrect");
        toast.error(LANG.EMAIL_NOT_FOUND);
        setError(LANG.EMAIL_NOT_FOUND);
      }
    },
  });

  return (
    <div className="main-wrapper authendication-pages forgot-password">
      {/* Page Content */}
      <div className="content">
        <div className="container wrapper no-padding">
          <div className="row no-margin  align-items-stretch">
            <div className="col-12 col-sm-12 col-lg-8 no-padding d-flex">
              <div className="banner-bg banner-bg-1 login">
                <div className="row h100 pb-0">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="row h-100">
                      <div className="col-md-12 h-100">
                        <img
                          src="/assets/img/authImg.jpg"
                          className="object-fit-cover img-fluid h-100 w-100"
                          alt="authImg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-12 col-lg-4 no-padding">
              <div className="dull-pg h-100">
                <div className="row no-margin vph-100 h-100 d-flex align-items-top justify-content-center">
                  <div className="col-sm-12 col-md-12 col-lg-12 mx-auto  d-flex align-items-center justify-content-center">
                    <div className="shadow-card d-flex align-items-top justify-content-center w-100">
                      <div className="shadow-card-inner">
                        <header className="text-center">
                          <ImageWithBasePath
                            src="assets/img/logo.svg"
                            className="img-fluid"
                            alt="Logo"
                          />
                        </header>
                        <h2 className="text-center">Forgot Password</h2>
                        <p className="text-center">
                          Enter your email address below and we'll send you an
                          email with instructions on how to change your password
                        </p>
                        <div className="tab-content" id="myTabContent">
                          <div
                            className="tab-pane fade show active"
                            id="user"
                            role="tabpanel"
                            aria-labelledby="user-tab"
                          >
                            {/* Login Form */}
                            <form onSubmit={formik.handleSubmit}>
                              <div className="form-group">
                                <label>Email</label>
                                <div className="group-img iconLeft email position-relative">
                                  <input
                                    className={
                                      error
                                        ? "form-control borderWarning"
                                        : "form-control commonInput"
                                    }
                                    type="text"
                                    placeholder="Enter your Email"
                                    {...formik.getFieldProps("email")}
                                  />
                                </div>
                                <ErrorText
                                  show={
                                    formik.touched.email && formik.errors.email
                                  }
                                  message={formik.errors?.email}
                                />
                              </div>

                              <button
                                type="submit"
                                className="btn btn-primary primaryButton register-btn d-inline-flex justify-content-center align-items-center w-100 btn-block"
                              >
                                Submit
                              </button>
                              <button
                                className="back-login-btn"
                                onClick={() => navigate(routes.login)}
                              >
                                Back to Login
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M4.66699 4.66406H11.3337V11.3307"
                                    stroke="#379fff"
                                    stroke-width="1.33333"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M4.66699 11.3307L11.3337 4.66406"
                                    stroke="#379fff"
                                    stroke-width="1.33333"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </button>
                            </form>
                            {/* /Login Form */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Content */}
    </div>
  );
};

export default ForgotPassword;
